// import { inject, Injectable } from '@angular/core';
// import { HttpClient, HttpParams } from '@angular/common/http';
// import { Observable } from 'rxjs';
//  import {
//   UndeliveredReason,
//   GetAllReasonsParams,
//   GetAllReasonsResponse,
// } from '../../../../pages/admin-dashboard/undelivered-reasons/undelivered-reasons.model';
// @Injectable({
//   providedIn: 'root',
// })
// export class UndeliveredReasonsService {
//   private http = inject(HttpClient);
//   private baseUrl = '/api/undelivered-reasons'; 
//   getAllReasons(queryParams: GetAllReasonsParams): Observable<GetAllReasonsResponse> {
//     let params = new HttpParams();

//     if (queryParams.reason) params = params.set('reason', queryParams.reason);
//     if (queryParams.createdOnFrom) params = params.set('createdOnFrom', queryParams.createdOnFrom);
//     if (queryParams.createdOnTo) params = params.set('createdOnTo', queryParams.createdOnTo);
//     if (queryParams.pageSize) params = params.set('pageSize', queryParams.pageSize.toString());
//     if (queryParams.pageNum !== undefined) params = params.set('pageNum', queryParams.pageNum.toString());
//     if (queryParams.orderBy) params = params.set('orderBy', queryParams.orderBy);
//     if (queryParams.orderDir) params = params.set('orderDir', queryParams.orderDir);

//     return this.http.get<GetAllReasonsResponse>(this.baseUrl, { params });
//   }

//   deleteReason(id: number): Observable<void> {
//     return this.http.delete<void>(`${this.baseUrl}/${id}`);
//   }
// }

import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  UndeliveredReason,
  GetAllReasonsParams,
  GetAllReasonsResponse,
  CreateReasonPayload,
  UpdateReasonPayload,
} from '../../pages/admin-dashboard/undelivered-reasons/undelivered-reasons.model';
import { AuthService } from '../auth-service';

@Injectable({
  providedIn: 'root',
})
export class UndeliveredReasonsService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.pharmacyMgtApiUrl}/orders/undelivered/reasons`;
  private authService = inject(AuthService);

getAllReasons(queryParams: Partial<GetAllReasonsParams>): Observable<GetAllReasonsResponse> {
    let params = new HttpParams();

    if (queryParams.quickSearch && queryParams.quickSearch.trim() !== '') {
      params = params.set('quickSearch', queryParams.quickSearch.trim());
    }
    if (queryParams.createdOnFrom && queryParams.createdOnFrom.trim() !== '') {
      params = params.set('createdOnFrom', queryParams.createdOnFrom.trim());
    }
    if (queryParams.createdOnTo && queryParams.createdOnTo.trim() !== '') {
      params = params.set('createdOnTo', queryParams.createdOnTo.trim());
    }
    if (queryParams.lastModifiedOnFrom && queryParams.lastModifiedOnFrom.trim() !== '') {
      params = params.set('lastModifiedOnFrom', queryParams.lastModifiedOnFrom.trim());
    }
    if (queryParams.lastModifiedOnTo && queryParams.lastModifiedOnTo.trim() !== '') {
      params = params.set('lastModifiedOnTo', queryParams.lastModifiedOnTo.trim());
    }

    if (queryParams.pageSize !== undefined && queryParams.pageSize !== null) {
      params = params.set('pageSize', queryParams.pageSize.toString());
    }
    if (queryParams.pageNum !== undefined && queryParams.pageNum !== null) {
      params = params.set('pageNum', queryParams.pageNum.toString());
    }

    // تجنب إرسال CREATION_ON أو CREATED_ON لمنع 400 Bad Request
    if (
      queryParams.orderBy &&
      queryParams.orderBy !== 'CREATION_ON' &&
      queryParams.orderBy !== 'CREATED_ON' &&
      queryParams.orderBy.trim() !== ''
    ) {
      params = params.set('orderBy', queryParams.orderBy.trim());
    }

    if (queryParams.orderDir && queryParams.orderDir.trim() !== '') {
      params = params.set('orderDir', queryParams.orderDir.trim());
    }

    return this.http.get<GetAllReasonsResponse>(this.baseUrl, {
      params,
      headers: this.getHeaders(),
    });
  }

  getReasonById(id: number): Observable<UndeliveredReason> {
    return this.http.get<UndeliveredReason>(`${this.baseUrl}/${id}`, {
      headers: this.getHeaders(),
    });
  }

  createReason(payload: CreateReasonPayload): Observable<UndeliveredReason> {
    return this.http.post<UndeliveredReason>(this.baseUrl, payload, {
      headers: this.getHeaders(),
    });
  }

  updateReason(id: number, payload: UpdateReasonPayload): Observable<UndeliveredReason> {
    return this.http.put<UndeliveredReason>(`${this.baseUrl}/${id}`, payload, {
      headers: this.getHeaders(),
    });
  }

  deleteReason(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`, {
      headers: this.getHeaders(),
    });
  }

  private getHeaders(): HttpHeaders {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }
}